import jwtDecode from "jwt-decode";
import {ssoApiService} from "api";
import {signOut} from "layout/main-layout/header/config";
import Notification from "components/common/notification/notification";
import {useDispatch} from "react-redux";
import {login} from "redux/reducer/auth";
import {useAppDispatch} from "redux/hooks";
export const checkTokenValidity = (token: string): boolean => {
  // kiem tra token co ton tai va khong het han
  if (token) {
    try {
      const decodedToken: any = jwtDecode(token);
      // if (decodedToken?.resource_access?.alina_dev_web?.roles) {
      //   localStorage.setItem(
      //     "roles",
      //     JSON.stringify(
      //       decodedToken?.resource_access?.alina_dev_web?.roles || []
      //     )
      //   );
      // }
      if (decodedToken.exp * 1000 >= Date.now()) {
        return true;
      }
    } catch (e) {
      return false;
    }
  }
  return false;
  ///// phai la return false
};
const handleLogin = async (token: string, dispatch) => {
  const valid = checkTokenValidity(token);

  if (valid) {
    dispatch(login(token));
  } else {
    const refreshDone = await refreshToken();
    if (refreshDone == true) {
      window.location.reload();
    }
  }
};
const refreshToken = async () => {
  let refreshDone = false;
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
      const params = {refreshToken: refreshToken};
      const res = await ssoApiService.refreshToken(params);

      if (res.data.status && res.data.access_token) {
        localStorage.setItem("token", res.data.access_token);
        localStorage.setItem("refreshToken", res.data.refresh_token);
        localStorage.setItem("idToken", res.data.id_token);
        refreshDone = true;
        // window.location.reload();
      } else {
        refreshDone = false;
        signOut();
      }
    }
  } catch (error) {
    Notification(
      "error",
      "Đã có lỗi khi lấy token mới. Vui lòng đăng nhập lại"
    );
    // signOut();
  }
  return refreshDone;
};
const refreshTokenNoNotification = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
      const params = {refreshToken: refreshToken};
      const res = await ssoApiService.refreshToken(params);

      if (res.data.status && res.data.access_token) {
        localStorage.setItem("token", res.data.access_token);
        localStorage.setItem("refreshToken", res.data.refresh_token);
        localStorage.setItem("idToken", res.data.id_token);
        // window.location.reload();
      } else {
      }
    }
  } catch (error) {
    // signOut();
  }
};

const clearLocalStorageExceptKey = (keys: string[]) => {
  let valuesToKeep = [];
  keys.forEach((key, index) => {
    valuesToKeep.push(localStorage.getItem(key));
  });
  localStorage.clear();
  keys.forEach((key, index) => {
    localStorage.setItem(key, valuesToKeep[index]);
  });
};

export {
  clearLocalStorageExceptKey,
  refreshToken,
  refreshTokenNoNotification,
  handleLogin,
};
